export { Container } from "@chakra-ui/react";
const baseStyle = {
    w: '100%',
    mx: 'auto',
    maxW: '60ch',
    px: '1rem'
};
export const ThemedContainer = {
    baseStyle
};

//# sourceMappingURL=Container.js.map